import { LineItem } from '~/commons/interfaces/models/checkout/cart/line-item/LineItem'
import { getSmallestMediaThumbnailUrl } from '~/helpers'

export function getCartItemCoverUrl(item: LineItem): string | null {
  return item.cover ? getSmallestMediaThumbnailUrl(item.cover) : null
}
